import { cn } from "@lib/cn";
import { MEDIA_LIB_DIALOG_MASONRY_SKELETON_HEIGHTS } from "../../constants";

const HEIGHTS = MEDIA_LIB_DIALOG_MASONRY_SKELETON_HEIGHTS;

interface IProps {
  className?: string;
  noAnim?: boolean;
}

export const MediaLibFilesSkeleton = ({ noAnim, className }: IProps) => {
  return (
    <div
      className={cn(
        "tw-grid tw-size-full tw-gap-2 tw-overflow-hidden",
        className,
      )}
      style={{
        gridTemplateColumns: `repeat(3, 1fr)`,
        gap: 8,
      }}
    >
      {Array.from({ length: 3 }, (_, idx) => (
        <ColSkeleton
          key={idx}
          heights={HEIGHTS[idx % HEIGHTS.length]}
          noAnim={noAnim}
        />
      ))}
    </div>
  );
};

const ColSkeleton = ({
  heights,
  noAnim,
}: {
  heights: number[];
  noAnim?: boolean;
}) => {
  return (
    <ul className="tw-grid tw-h-full tw-list-none tw-content-start tw-gap-2">
      {Array.from({ length: 12 }, (_, idx) => (
        <li
          key={idx}
          style={{
            height: heights[idx % heights.length],
          }}
          className={cn(
            "tw-h-full tw-w-full tw-rounded tw-bg-blue-50",
            !noAnim && "tw-animate-skeleton-loading",
          )}
        />
      ))}
    </ul>
  );
};
